import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import SecurityAccessSimulator from '../components/tools/securityAccess/SecurityAccessSimulator';
import { Alert, AlertTitle, AlertDescription } from '../components/ui/alert';
import { ShieldAlert } from 'lucide-react';

const SecurityAccessSimulatorPage = () => (
  <div className="min-h-screen" data-testid="security-access-simulator-page">
    <PageHero
      eyebrow="Diagnostic Tools"
      title="Security Access Seed-Key Simulator"
      description="Practice the UDS (ISO 14229) 0x27 SecurityAccess Seed -> Key -> Verification handshake — request a seed, derive a key with a training algorithm, and see exactly how an ECU accepts, rejects, or locks out the attempt."
      backTo="/tools"
      backLabel="Back to Tools"
      testId="security-access-simulator-hero"
    />
    <section className="py-12 md:py-16">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 space-y-6">
        <Alert variant="destructive" data-testid="security-access-disclaimer">
          <ShieldAlert className="h-4 w-4" />
          <AlertTitle className="font-chivo uppercase tracking-tight text-sm">Training Tool — Not for Real ECUs</AlertTitle>
          <AlertDescription>
            Every algorithm in this simulator is a fictional teaching exercise, not a real
            OEM or vehicle seed-key algorithm. It does not implement, source, or reveal any
            real unlock key. Use it only to learn the 0x27 request/response flow and lockout
            behavior.
          </AlertDescription>
        </Alert>

        <SecurityAccessSimulator />
        <ToolGuideCta guidePath="/tools/diagnostic/security-access-simulator/guide" toolName="Security Access Seed-Key Simulator" />
      </div>
    </section>
  </div>
);

export default SecurityAccessSimulatorPage;
